/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Activity_Sync_ErrorInputs */



/**
* | output |
* | --- |
* | "{name}: sync failed" |
*
* @param {Activity_Sync_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const activity_sync_error = /** @type {((inputs: Activity_Sync_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Activity_Sync_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.name}: Synchronisierung fehlgeschlagen`)
	return /** @type {LocalizedString} */ (`${i?.name}: sync failed`)
});